export default function UseCrypto() {}
